import {
    SET_DIVISIONAL_APPROVER_REQUISITION_TYPE,
} from "./DivisionalApproverRequisitionTypeType";

const reducers = (state = [], action: any) => {
    if (action.type === SET_DIVISIONAL_APPROVER_REQUISITION_TYPE) {
        return {
            ...state,
            divisionalApproverRequisitionTypeList: action.divisionalApproverRequisitionTypeList,
        };
    }
    else {
        return state;
    }
};

export default reducers;
